import { isNull } from "@/logic/helpers/utils";

export const isPriceablePassenger = (passenger) => {
    if (isNull(passenger.gender)) return false;
    return true;
}